<template>
  <section class="specialization-section" :class="{ 'is-active': isActive }">
    <!-- ===== 데스크탑: 3컬럼 레이아웃 ===== -->
    <div class="desktop-layout">
      <!-- 좌측 -->
      <div class="zone zone-left">
        <div class="bg-image">
          <img src="@/assets/bg_premium1.jpg" alt="" />
        </div>
        <div class="section-text">
          <div class="header-text">
            <p class="text-line anim-item" :class="{ 'anim-in': animReady }">엘리프 한신더휴 수원</p>
            <p class="text-line highlight anim-item" :class="{ 'anim-in': animReady }">수원 주거의 새 기준이 되다</p>
          </div>
          <transition name="crossfade">
            <div class="page-wrap" :key="'left-' + currentPage">
              <div class="content-block">
                <h3 class="content-title anim-item" :class="{ 'anim-in': animReady }">{{ pages[currentPage].left.title }}</h3>
                <p class="content-desc anim-item" :class="{ 'anim-in': animReady }" v-html="pages[currentPage].left.desc"></p>
                <p class="content-eng anim-item" :class="{ 'anim-in': animReady }">{{ pages[currentPage].left.eng }}</p>
              </div>
              <img :src="pages[currentPage].left.image" alt="" class="content-img anim-item" :class="{ 'anim-in': animReady }" />
            </div>
          </transition>
        </div>
      </div>

      <!-- 중간: 흰색 -->
      <div class="zone zone-mid">
        <div class="zone-content">
          <transition name="crossfade">
            <div class="page-wrap" :key="'mid-' + currentPage">
              <img :src="pages[currentPage].mid.image" alt="" class="content-img anim-item" :class="{ 'anim-in': animReady }" />
              <h3 class="content-title beige anim-item" :class="{ 'anim-in': animReady }">{{ pages[currentPage].mid.title }}</h3>
              <p class="content-desc anim-item" :class="{ 'anim-in': animReady }" v-html="pages[currentPage].mid.desc"></p>
              <p class="content-eng anim-item" :class="{ 'anim-in': animReady }">{{ pages[currentPage].mid.eng }}</p>
            </div>
          </transition>

          <div class="view-btn anim-item" :class="{ 'anim-in': animReady }" @click="$router.push('/product/premium')">
            <svg class="view-rotate-text" viewBox="0 0 160 160">
              <defs>
                <path id="specCirclePath" d="M80,80 m-65,0 a65,65 0 1,1 130,0 a65,65 0 1,1 -130,0" />
              </defs>
              <text text-anchor="middle">
                <textPath href="#specCirclePath" startOffset="25%">VIEW MORE</textPath>
              </text>
              <text text-anchor="middle">
                <textPath href="#specCirclePath" startOffset="75%">VIEW MORE</textPath>
              </text>
            </svg>
            <span class="view-center">VIEW</span>
          </div>
        </div>
      </div>

      <!-- 우측 -->
      <div class="zone zone-right">
        <div class="bg-image">
          <img src="@/assets/bg_premium1.jpg" alt="" />
        </div>
        <div class="section-text section-text-right">
          <transition name="crossfade">
            <div class="page-wrap" :key="'right-' + currentPage">
              <div class="content-block">
                <h3 class="content-title anim-item" :class="{ 'anim-in': animReady }">{{ pages[currentPage].right.title }}</h3>
                <p class="content-desc anim-item" :class="{ 'anim-in': animReady }" v-html="pages[currentPage].right.desc"></p>
                <p class="content-eng anim-item" :class="{ 'anim-in': animReady }">{{ pages[currentPage].right.eng }}</p>
              </div>
              <img :src="pages[currentPage].right.image" alt="" class="content-img anim-item" :class="{ 'anim-in': animReady }" />
            </div>
          </transition>
        </div>
      </div>
    </div>

    <!-- ===== 모바일: 6개 카드 리스트 ===== -->
    <div class="mobile-layout">
      <div class="mobile-header">
        <p class="text-line">엘리프 한신더휴 수원</p>
        <p class="text-line highlight">수원 주거의 새 기준이 되다</p>
      </div>
      <div class="mobile-cards">
        <div
          v-for="(item, index) in allItems"
          :key="index"
          class="mobile-card"
        >
          <img :src="item.image" :alt="item.title" class="mobile-card-img" />
          <div class="mobile-card-text">
            <p class="mobile-card-eng">{{ item.eng }}</p>
            <h3 class="mobile-card-title">{{ item.title }}</h3>
            <p class="mobile-card-desc" v-html="item.desc"></p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SpecializationSection',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentPage: 0,
      isScrollLocked: false,
      animReady: false,
      pages: [
        {
          left: {
            title: '서수원 새 도시 중심',
            desc: '약 3만 3천여 세대<br>당수 · 호매실지구의 중심',
            eng: 'New CENTRAL CITY',
            image: require('@/assets/premiumsection/slide_premium1.jpg')
          },
          mid: {
            title: '더 빨라질 광역 교통',
            desc: '수원역 1호선, 신분당선 연장(예정),<br>GTX-C(예정)',
            eng: 'FAST TRAFFIC',
            image: require('@/assets/premiumsection/slide_premium2.jpg')
          },
          right: {
            title: '걸어가는 안심 교육',
            desc: '당수1지구 유일 초품아(예정),<br>가까운 초·중·고',
            eng: 'EDUCATION',
            image: require('@/assets/premiumsection/slide_premium3.jpg')
          }
        },
        {
          left: {
            title: '가까운 쾌적 자연',
            desc: '단지 바로 앞 당수천과<br>당수공원(예정), 칠보산',
            eng: 'NATURE',
            image: require('@/assets/premiumsection/slide_premium4.jpg')
          },
          mid: {
            title: '넉넉한 공간 설계',
            desc: '최대 3배 더 큰 커뮤니티, 74㎡ ~120㎡ 중대형 평형<br>(법정 대비 C3BL 2.8배, D3BL 3배)',
            eng: 'WIDE SPACE',
            image: require('@/assets/premiumsection/slide_premium5.jpg')
          },
          right: {
            title: '1,149세대 브랜드타운',
            desc: '계룡건설과 한신공영이 함께 만드는<br>명품 대단지',
            eng: 'BEST BRAND',
            image: require('@/assets/premiumsection/slide_premium6.jpg')
          }
        }
      ]
    }
  },
  computed: {
    allItems() {
      const items = []
      this.pages.forEach(page => {
        items.push(page.left)
        items.push(page.mid)
        items.push(page.right)
      })
      return items
    }
  },
  watch: {
    isActive(val) {
      if (val) {
        this.currentPage = 0
        this.animReady = false
        setTimeout(() => { this.animReady = true }, 100)
      } else {
        this.animReady = false
      }
    },
    currentPage() {
      this.animReady = false
      setTimeout(() => { this.animReady = true }, 150)
    }
  },
  methods: {
    handleScroll(direction) {
      if (this.isScrollLocked) return

      if (direction === 'down') {
        if (this.currentPage === 0) {
          this.isScrollLocked = true
          this.currentPage = 1
          setTimeout(() => { this.isScrollLocked = false }, 1200)
        } else {
          this.$emit('next-section')
        }
      } else {
        if (this.currentPage === 1) {
          this.isScrollLocked = true
          this.currentPage = 0
          setTimeout(() => { this.isScrollLocked = false }, 1200)
        } else {
          this.$emit('prev-section')
        }
      }
    }
  }
}
</script>

<style scoped>
.specialization-section {
  height: 100vh;
  position: relative;
  overflow: hidden;
  display: flex;
}

.zone {
  position: relative;
  overflow: hidden;
  height: 100%;
}

.zone-left {
  flex: 1;
}

.zone-mid {
  width: 33.33%;
  background: #fff;
  flex-shrink: 0;
}

.zone-right {
  flex: 1;
}

.bg-image {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.bg-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 왼쪽/오른쪽 텍스트 */
.section-text {
  position: absolute;
  top: 200px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 80px);
  max-width: 400px;
  z-index: 1;
}

.section-text-right {
  top: 200px;
}

/* 중간 콘텐츠 */
.zone-content {
  position: absolute;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 80px);
  max-width: 400px;
  z-index: 1;
}

.header-text {
  margin-bottom: 20px;
}

.text-line {
  font-family: var(--font-family3);
  font-size: 32px;
  font-weight: 400;
  color: #333;
  line-height: 1.6;
}

.text-line.highlight {
  font-family: var(--font-family3);
  font-weight: 800;
  color: var(--thehue-primary);
}

.content-block {
  margin-top: 45px;
}

.content-title {
  font-family: var(--font-family);
  font-size: 28px;
  font-weight: 700;
  color: var(--thehue-primary);
  margin-bottom: 12px;
}

.content-title.beige {
  color: #b8a99a;
}

.content-desc {
  font-family: var(--font-family);
  font-size: 16px;
  font-weight: 400;
  color: #888;
  line-height: 1.7;
}

.content-eng {
  font-family: var(--font-family2);
  font-size: 11px;
  font-weight: 400;
  color: var(--thehue-primary);
  letter-spacing: 3px;
  margin-top: 65px;
}

.content-img {
  margin-top: 65px;
  width: 100%;
  max-width: 400px;
  height: auto;
  border-radius: 0;
}

/* page-wrap for crossfade overlap */
.page-wrap {
  width: 100%;
}

.section-text,
.zone-content {
  overflow: visible;
}

/* 크로스페이드: 동시에 사라지고 나타남 */
.crossfade-enter-active {
  transition: opacity 0.9s cubic-bezier(0.16, 1, 0.3, 1), transform 0.9s cubic-bezier(0.16, 1, 0.3, 1);
}

.crossfade-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.crossfade-enter {
  opacity: 0;
  transform: translateY(50px);
}

.crossfade-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

/* 개별 아이템 순차 애니메이션 */
.anim-item {
  opacity: 0;
  transform: translateY(25px);
  transition: opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1), transform 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.anim-item.anim-in {
  opacity: 1;
  transform: translateY(0);
}

/* 순차 딜레이 - zone-left */
.zone-left .header-text .anim-item:nth-child(1) { transition-delay: 0.1s; }
.zone-left .header-text .anim-item:nth-child(2) { transition-delay: 0.25s; }
.zone-left .content-block .anim-item:nth-child(1) { transition-delay: 0.35s; }
.zone-left .content-block .anim-item:nth-child(2) { transition-delay: 0.5s; }
.zone-left .content-block .anim-item:nth-child(3) { transition-delay: 0.65s; }
.zone-left .content-img { transition-delay: 0.8s; }

/* 순차 딜레이 - zone-mid */
.zone-mid .content-img { transition-delay: 0.2s; }
.zone-mid .content-title { transition-delay: 0.4s; }
.zone-mid .content-desc { transition-delay: 0.55s; }
.zone-mid .content-eng { transition-delay: 0.7s; }
.zone-mid .view-btn { transition-delay: 0.85s; }

/* 순차 딜레이 - zone-right */
.zone-right .content-block .anim-item:nth-child(1) { transition-delay: 0.3s; }
.zone-right .content-block .anim-item:nth-child(2) { transition-delay: 0.45s; }
.zone-right .content-block .anim-item:nth-child(3) { transition-delay: 0.6s; }
.zone-right .content-img { transition-delay: 0.75s; }

/* VIEW 버튼 */
.view-btn {
  margin-top: 65px;
  margin-left: auto;
  margin-right: auto;
  width: 110px;
  height: 110px;
  border-radius: 50%;
  background: var(--thehue-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: visible;
  position: relative;
  transition: background 0.3s ease;
}

.view-btn:hover {
  background: var(--sub-color);
}

.view-rotate-text {
  position: absolute;
  width: 155%;
  height: 155%;
  animation: rotate 10s linear infinite;
}

.view-rotate-text text {
  font-family: var(--font-family2);
  font-size: 11px;
  font-weight: 600;
  fill: var(--thehue-primary);
  letter-spacing: 2px;
}

.view-center {
  font-family: var(--font-family2);
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 1px;
  transition: color 0.3s ease;
}

.view-btn:hover .view-center {
  color: var(--thehue-primary);
}

@keyframes rotate {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* ========== 데스크탑 레이아웃 ========== */
.desktop-layout {
  display: flex;
  height: 100%;
  width: 100%;
}

/* ========== 모바일 레이아웃 (기본: 숨김) ========== */
.mobile-layout {
  display: none;
}

/* ========== Mobile Responsive ========== */
@media (max-width: 768px) {
  .specialization-section {
    height: auto;
    overflow: hidden;
  }

  /* 데스크탑 3컬럼 숨기고 모바일 리스트 표시 */
  .desktop-layout {
    display: none;
  }

  .mobile-layout {
    display: block;
    background: #fff;
    padding: 48px 0 40px;
  }

  .mobile-header {
    padding: 0 24px 24px;
    text-align: center;
  }

  .mobile-header .text-line {
    font-size: 18px;
    line-height: 1.5;
  }

  .mobile-header .text-line.highlight {
    font-size: 18px;
  }

  .mobile-cards {
    display: flex;
    flex-direction: column;
    gap: 0;
    align-items: center;
    width: 100%;
  }

  .mobile-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .mobile-card-img {
    width: 100%;
    height: 220px;
    object-fit: cover;
    display: block;
  }

  .mobile-card-text {
    padding: 24px 24px 32px;
    background: #fff;
    text-align: center;
    width: 100%;
    box-sizing: border-box;
  }

  .mobile-card:nth-child(even) .mobile-card-text {
    background: #f9f8f5;
  }

  .mobile-card-eng {
    font-family: var(--font-family2);
    font-size: 10px;
    font-weight: 500;
    color: var(--thehue-primary);
    letter-spacing: 3px;
    margin-bottom: 8px;
  }

  .mobile-card-title {
    font-family: var(--font-family);
    font-size: 18px;
    font-weight: 700;
    color: var(--thehue-primary);
    margin-bottom: 8px;
  }

  .mobile-card-desc {
    font-family: var(--font-family);
    font-size: 13px;
    font-weight: 400;
    color: #888;
    line-height: 1.6;
  }
}

</style>
